module.exports = __webpack_public_path__ + "img/58.1.fd5ca491.jpg";